(function($) { 

  const $homeslider = $('.wp-block-eedee-block-gutenslider')
  const $searchcategoriesfind = $('.SearchCategoriesFind')
  $homeslider.append($searchcategoriesfind.remove())

})(jQuery)